<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  

  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  
  
}
</style>
<style  src="@/assets/css/reset.css"></style>

<style  src="@/assets/css/bootstrap.min.css"></style>
 <!--slick-->
 <!--///////////////////////課程內頁用///////////////////////-->

<style  src="@/assets/vendor/slick/slick.css"></style>
<style  src="@/assets/vendor/slick/slick-theme.css"></style>
 <!-- lightbox -->
<style  src="@/assets/vendor/glightbox-master/glightbox.css"></style>
 <!--///////////////////////課程內頁用 end///////////////////////-->
 <!--search-->
 <style  src="@/assets/vendor/expandingSearchBar/component.css"></style>
 <!--pace-->
<!--<style  src="@/assets/vendor/pace/css/dataurl.css"></style>-->
<style  src="@/assets/vendor/animate.css/animate.min.css"></style>
<style  src="@/assets/css/common.css"></style>
<style  src="@/assets/css/common_rwd.css"></style>
<style  src="@/assets/css/page.css"></style>
<style  src="@/assets/css/page_rwd.css"></style>
<style  src="@/assets/css/css.css"></style>





// WEBPACK FOOTER //
// src/App.vue